import { render, staticRenderFns } from "./DashboardModal.vue?vue&type=template&id=6b9b8bec&scoped=true"
import script from "./DashboardModal.vue?vue&type=script&lang=js"
export * from "./DashboardModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardModal.vue?vue&type=style&index=0&id=6b9b8bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b8bec",
  null
  
)

export default component.exports